module.exports = __webpack_public_path__ + "media/application/images/icons/table-previous-ab34351a0f4487f5e1f0212b721a42ad.svg";